module.exports = __webpack_public_path__ + "static/media/logo.40dce114.svg";